import gql from '@/core/setup/api';
import { Region } from '@sbvr/lbe-types';

export async function getRegions () {
  const query = `{
    regions {
      name
      isoRegionCode
      countryCode
    }
  }`;
  const { regions } = await gql.request(query) as { regions: Region[] };
  return regions;
};
